import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom';
 
 
import { EditContact } from './EditContact';
import { getBackendSettings } from '../plan-list/core/_requests';
import EditPlan from './EditPlan';

export const EditPlanInfoWrapper = () => {
 const { id } = useParams();
  const [data, setData] = useState<any>(null)
  useEffect(() => { 
    getBackendSettings().then((res) => {
     
      setData(res)
    })
  }, [])
  if (data) {
    
    return <EditPlan initialValues={data} />
  }
  return null
}